import Http from '@/services/httpAcademy'

export const listEbooks = (params) =>
	Http.get('/admin/ebooks', { params })

export const getEbook = (id) =>
	Http.get(`/admin/ebooks/${id}`)

export const createEbook = (data) =>
	Http.post('/admin/ebooks', data)

export const updateEbook = (id, data) =>
	Http.put(`/admin/ebooks/${id}`, data)

export const uploadThumbnail = (id, formData) =>
	Http.post(`/admin/ebooks/${id}/thumbnail`, formData, {
		headers: { 'Content-Type': 'multipart/form-data' },
	})

export const uploadThumbnailLocale = (id, locale, formData) =>
	Http.post(`/admin/ebooks/${id}/thumbnail/${locale}`, formData, {
		headers: { 'Content-Type': 'multipart/form-data' },
	})

export const uploadPdf = (id, formData) =>
	Http.post(`/admin/ebooks/${id}/pdf`, formData, {
		headers: { 'Content-Type': 'multipart/form-data' },
	})

export const uploadPdfLocale = (id, locale, formData) =>
	Http.post(`/admin/ebooks/${id}/pdf/${locale}`, formData, {
		headers: { 'Content-Type': 'multipart/form-data' },
	})

export const getWorkbookStatus = id =>
	Http.get(`/admin/ebooks/${id}/workbook`)

export const uploadWorkbook = (id, locale, formData) =>
	Http.post(`/admin/ebooks/${id}/workbook/${locale}`, formData, {
		headers: { 'Content-Type': 'multipart/form-data' },
	})

export const getBonusStatus = id =>
	Http.get(`/admin/ebooks/${id}/bonus`)

export const uploadBonus = (id, locale, formData) =>
	Http.post(`/admin/ebooks/${id}/bonus/${locale}`, formData, {
		headers: { 'Content-Type': 'multipart/form-data' },
	})

export const setBonusRelease = (id, release) =>
	Http.post(`/admin/ebooks/${id}/bonus/release`, { release })

export const resyncRenderCounts = (id) =>
	Http.post(`/admin/ebooks/${id}/resync-render-counts`)

export const getRenderStatus = (id) =>
	Http.get(`/admin/ebooks/${id}/render-status`)

export const renderPages = (id, locale = null) =>
	Http.post(locale ? `/admin/ebooks/${id}/render-pages/${locale}` : `/admin/ebooks/${id}/render-pages`)

export const repairPages = (id, locale) =>
	Http.post(`/admin/ebooks/${id}/repair-pages/${locale}`)

export const testDownload = (id, locale = 'en') =>
	Http.post(`/admin/ebooks/${id}/test-download`, { locale })

export const deleteEbook = (id) =>
	Http.delete(`/admin/ebooks/${id}`)
